/**
 * Einzige Quelle für die Versionsnummer der App.
 *
 * Vorher stand sie an fünf Stellen fest verdrahtet — zwei davon als Konstante
 * `APP_VERSION`, drei als reiner Fließtext („Version 1.16.0 · …"). Beim
 * Hochzählen wurden regelmäßig nur die Konstanten gefunden, sodass Workspace,
 * Lager-Ansicht und Sidebar auf einem alten Stand stehen blieben.
 *
 * Beim Deploy wird ausschließlich diese Zeile geändert.
 */
export const APP_VERSION = "1.58.2"
